export default __webpack_public_path__ + "static/william@2x-ba5fc71132cce002bdb33b0d54281a55.jpg";